'use client';
import React, { useEffect, useState } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import Notification, { ToastT } from '@/shared/Notification/notification';
import styles from './styles.module.css';

const Notifications = () => {
  const { notifications, deleteNotificationId } = useApp();
  const [animationStates, setAnimationStates] = useState<
    Record<string, ToastT>
  >({});

  useEffect(() => {
    notifications.forEach((notification) => {
      const id = notification.id;
      if (!id) return;

      if (!animationStates[id]) {
        setAnimationStates((prevStates) => ({
          ...prevStates,
          [id]: 'entering',
        }));

        setTimeout(() => {
          setAnimationStates((prevStates) => ({
            ...prevStates,
            [id]: 'visible',
          }));
        }, 10);

        setTimeout(() => {
          setAnimationStates((prevStates) => ({
            ...prevStates,
            [id]: 'exiting',
          }));

          // После завершения анимации выхода удаляем из состояния
          setTimeout(() => {
            deleteNotificationId(id);
          }, 500);
        }, 3000);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications, deleteNotificationId]);

  return (
    <div className={styles.wrapperNotification}>
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          text={notification.text}
          type={notification.type}
          animationState={animationStates[notification.id!] || 'entering'}
        />
      ))}
    </div>
  );
};

export default Notifications;
